import { datadogLogs } from '@datadog/browser-logs';

import { BUILD_NUM } from '../../../BuildConstants';
import { getWLID } from '../../../weborder/Utilities';
import { flagService } from '../flagService';

const isDataDogRequired = (): boolean => {
  const env = process.env.REACT_APP_ENVIRONMENT;
  return env === 'production';
};

export const initialise = (): void => {
  if (isDataDogRequired()) {
    // Details of implementation: https://docs.datadoghq.com/logs/log_collection/javascript/#initialization-parameters
    datadogLogs.init({
      beforeSend: (log) => {
        // eslint-disable-next-line no-param-reassign
        log.user = {};
      },
      clientToken: process.env.REACT_APP_DATADOG_AUTH_TOKEN,
      forwardErrorsToLogs: false,
      sampleRate: 100,
      service: 'web-order',
      site: 'us3.datadoghq.com',
      telemetrySampleRate: 0,
      version: BUILD_NUM,
    });
  }
};

export type LogTypes = 'debug' | 'error' | 'info' | 'log' | 'warn';

const sendLog = (mode: LogTypes, message: string, meta): void => {
  const wlID = getWLID();
  const payload = {
    version: BUILD_NUM,
    wlID,
    message,
    meta,
  };

  if (isDataDogRequired() && !flagService.isFlagOn('avoidDataDog')) {
    datadogLogs.logger[mode](message, { payload });
  } else {
    // eslint-disable-next-line no-console
    console[mode](message, payload);
  }
};

type LoggerType = {
  [key in LogTypes]: (message: string, data?: object) => void;
};

export const logger: LoggerType = {
  debug: (message: string, data?: object): void =>
    sendLog('debug', message, data),
  error: (message: string, data?: object): void =>
    sendLog('error', message, data),
  info: (message: string, data?: object): void =>
    sendLog('info', message, data),
  log: (message: string, data?: object): void => sendLog('log', message, data),
  warn: (message: string, data?: object): void =>
    sendLog('warn', message, data),
};
